var BASWebServices;
(function (BASWebServices) {
    var HomepageController = (function () {
        function HomepageController($scope, $location, serviceListService) {
            this.$scope = $scope;
            this.$location = $location;
            this.serviceListService = serviceListService;
            $scope.hc = this;
        }
        HomepageController.prototype.getServices = function () {
            return this.serviceListService.getServicesRandomized();
        };
        HomepageController.prototype.redirectToUrl = function (service) {
            window.location = service.href;
        };
        return HomepageController;
    }());
    BASWebServices.HomepageController = HomepageController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=HomepageController.js.map